/* eslint-disable react/display-name */
import React, { forwardRef, Ref } from 'react';
import { Input, InputRef } from 'antd';
import { twJoin, twMerge } from '@shared/utils/twMerge';
import './TextArea.scss';
import { TextAreaProps } from 'antd/lib/input/TextArea';

type AppTextAreaProps = TextAreaProps & {
  label?: string;
  dark?: boolean;
  classNameLabel?: string;
  classNameLabelText?: string;
  helperText?: string;
  errors?: string;
  inOneLine?: boolean;
  classNameInputWrapper?: string;
};

const { TextArea: AntdTextArea } = Input;
const inputWrapperDefault = 'max-w-[41.2rem] grow';

export const TextArea = forwardRef<HTMLTextAreaElement, AppTextAreaProps>(
  (
    {
      inOneLine,
      dark,
      classNameLabel,
      classNameInputWrapper = '',
      classNameLabelText,
      ...props
    }: AppTextAreaProps,
    ref
  ) => {
    const styleInOneLineWrapper = inOneLine ? 'flex-row justify-between' : '';
    const styleInOneLineLabel = inOneLine ? 'pt-[1.2rem]' : '';
    return (
      <div
        className={twJoin('D7-Textarea w-full', dark && 'dark')}
        data-testid={`${props.name}-input-container`}
      >
        <label className={twMerge('flex w-full flex-col ', styleInOneLineWrapper, classNameLabel)}>
          {props.label && (
            <div
              className={twMerge(
                'text-1424 font-semibold',
                styleInOneLineLabel,
                classNameLabelText
              )}
            >
              {props.label}
              {props.required && <span className={'text-redOrange'}>*</span>}
            </div>
          )}
          <div className={twMerge(inputWrapperDefault, classNameInputWrapper)}>
            <AntdTextArea
              {...props}
              ref={ref as unknown as Ref<InputRef>}
              className={twMerge(props.errors ? 'ant-input-error' : '', props.className)}
            />
            {props.errors && (
              <span
                data-testid={`${props.name}-error-container`}
                className={twMerge(
                  'ant-input-error text-1420 font-normal',
                  props.errors ? 'visible' : 'invisible',
                  props.className
                )}
              >
                {props.errors}
              </span>
            )}
          </div>
        </label>
      </div>
    );
  }
);
